/** Accepted server decision presentation; never a client-side comparison calculation. */
import * as z from 'zod';
const text = z.string();
const nullableText = text.nullable();
export const shopifyStudyOverviewPresentationSchema = z.discriminatedUnion('status', [
    z.strictObject({
        status: z.literal('available'),
        reason: z.null(),
        headline: text,
        tone: z.enum(['positive', 'caution', 'negative', 'neutral']),
        recommendation: text,
        detail: nullableText,
        explanation: z.null(),
    }),
    z.strictObject({
        status: z.literal('unavailable'),
        reason: z.enum([
            'not_ready',
            'missing_decision',
            'unknown_decision',
            'invalid_arm_reference',
            'missing_single_arm_result',
            'missing_accepted_arms',
            'partial_comparison',
        ]),
        headline: z.literal('Result unavailable'),
        tone: z.literal('neutral'),
        recommendation: z.null(),
        detail: z.null(),
        explanation: text,
    }),
]);
//# sourceMappingURL=shopify-study-results-overview.js.map